import { catchError } from 'rxjs/operators';
import { AdSchedule } from './../../../interfaces/adschedule';
import { QueryParameter } from 'app/interfaces/queryString';
import { SapiService, SapiQueryResponse } from 'app/services/sapi.service';
import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Adunit } from 'app/components/adservices/adunit/adunit-list.component';
import { of } from 'rxjs';

@Component({
	selector: 'playout-details-advertising',
	templateUrl: './playout-details-advertising.component.html',
	styleUrls: ['./playout-details-advertising.component.scss']
})

export class PlayoutDetailsAdvertisingComponent implements OnInit {

	@Input() playout: any;
	@Input() form: NgForm;

	adSchedule: AdSchedule;
	loadingAdSchedule = false;

	constructor(private sapiService: SapiService) {

	}

	ngOnInit() {
		const queryParams: QueryParameter[] = [{ name: 'q', values: ['playoutCodes:' + this.playout.label] }];

		this.loadingAdSchedule = true;
		this.sapiService.query('adschedule', queryParams)
			.pipe(
				catchError(() => {
					this.loadingAdSchedule = false;
					return of(null);
				})
			)
			.subscribe((sapiQueryResponse: SapiQueryResponse) => {
				this.adSchedule = sapiQueryResponse?.items?.[0] as AdSchedule;
				this.loadingAdSchedule = false;
			});
	}
}
